export default function getParentPath(path: string) {
  return path.substring(0, path.lastIndexOf('/'));
}
